<div
  *transloco="let t; read: 'widgets.comments'"
  class="xi-modal__container comment-dialog__container"
>
  @if (mode === 'CREATE') {
    <h2>
      <div class="xi-modal__title kxi-text-center comment-dialog__title">
        {{ t('add-comment') }}
      </div>
    </h2>
  } @else {
    <div class="xi-modal__title kxi-text-center comment-dialog__title">
      <h2>
        {{ comment.title }}
      </h2>
      <div>
        @if (dataChangeText) {
          <xi-icon
            icon="document_alert_filled"
            color="error"
            [tooltipProps]="{ text: dataChangeText }"
          ></xi-icon>
        }
      </div>
      <div>
        @if (!options.isCommentVisible) {
          <xi-icon icon="visibility_off" [tooltip]="{ text: t('comment-not-visible') }"></xi-icon>
        }
      </div>
      @if (!options.isReadOnly) {
        <div class="comment-dialog__title-actions">
          @if (comment.type === 'smart-summary') {
            <xi-icon-button
              icon="lightbulb"
              [disabled]="!options.smartSummaryExists"
              color="CX"
              (onClick)="onSmartSummaryClicked()"
              [tooltip]="{
                text: options.smartSummaryExists
                  ? t('open-smart-summary')
                  : t('smart-summary-disabled-deleted'),
              }"
            ></xi-icon-button>
          }
          <xi-icon-button
            [disabled]="options.isDashboardLocked"
            icon="trash"
            color="CX"
            (onClick)="onDelete()"
            [tooltip]="{ text: t('delete') }"
          ></xi-icon-button>
        </div>
      }
    </div>
    <div class="comment-dialog__subtitle">
      {{ t('created-by-on', { user: commentCreator, date: comment.createdAt | lexDate }) }}
    </div>
  }

  <form
    class="xi-modal__content comment-dialog__content"
    [formGroup]="commentForm"
    (ngSubmit)="onSave()"
  >
    <xi-icon-button
      [icon]="isPinned('title') ? 'pin_filled' : 'pin'"
      [disabled]="!canPin('title')"
      [tooltip]="{ text: pinTooltip }"
      (onClick)="togglePinned('title')"
      type="button"
    ></xi-icon-button>

    <xi-input-field
      formControlName="title"
      [status]="titleStatus"
      [label]="t('title')"
      [placeholder]="t('add-title')"
      name="title"
      [maxCharsAllowed]="{
        max: 40,
        allowOvertype: true,
        errorMessage: t('title-maxlength', { maxlength: 40 }),
      }"
      appAutoFocus="xiInput"
    ></xi-input-field>

    <xi-icon-button
      [icon]="isPinned('summary') ? 'pin_filled' : 'pin'"
      [tooltip]="{ text: pinTooltip }"
      [disabled]="!canPin('summary')"
      (onClick)="togglePinned('summary')"
      type="button"
    >
    </xi-icon-button>

    <xi-text-area
      formControlName="summary"
      [status]="summaryStatus"
      [label]="t('summary')"
      [placeholder]="t('comment-here')"
      name="summary"
      [maxCharsAllowed]="{
        max: 300,
        allowOvertype: true,
        errorMessage: t('summary-maxlength', { maxlength: 300 }),
      }"
    ></xi-text-area>

    <div></div>

    <xi-text-area
      formControlName="details"
      [label]="t('details')"
      [placeholder]="t('add-details')"
      name="details"
    ></xi-text-area>
  </form>

  <div class="xi-modal__actions comment-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <div class="xi-loader-button-container">
      @if (!options.isReadOnly) {
        <xi-default-button
          [text]="mode === 'CREATE' ? t('save') : t('update')"
          [disabled]="isSaveDisabled()"
          [tooltip]="saveButtonTooltip"
          [tooltipDisplayOnDisabled]="true"
          (onClick)="onSave()"
        ></xi-default-button>
      }
      @if (isSaving()) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</div>
